import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	expandableSectionTitle: {
		id: 'polaris-component-collection-delete-modal.views-list.expandable-section-title',
		defaultMessage: 'Check the views used in this roadmap',
		description: 'Title of the expandable section in the Delete Roadmap confirmation modal window',
	},
});
